import {AfterViewInit, Component, ElementRef, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {MaterialService} from "../../classes/material.service";
import {SocketUserControl} from "../../services/sockets"
import { MENU_ITEMS, MENU_ADMIN_ITEMS } from './pages-menu';
   import { GoogleAnalyticsService } from '../../../@core/utils/analytics.service';
import {  NbToastrService, NbGlobalPosition} from '@nebular/theme';

import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss'],
  providers: [SocketUserControl]
})
export class SiteLayoutComponent implements AfterViewInit,OnInit, OnDestroy {

   menu = [];
  loaded:boolean = false;
  reloadsCount: number = 0;



  constructor(
    private authService: AuthService,
    private router: Router,
    private socket: SocketUserControl,
   public gAnalytics: GoogleAnalyticsService,
    private toastrService: NbToastrService,
	private translateService: TranslateService
    
  ) { 


     }


  ngOnInit() {
	this.reloadsCount = 0
    this.loadUserData()

    this.socket.on('cmd',this.onCommand.bind(this))

    this.socket.connect()
    
    
  }



  onCommand(data){
 
	  if(data?.type === 'streamStoppedByLimit'){
		 
		   this.toastrService.show('Трансляція зупинена','Перевищено ліміт у безкоштовному тарифі',{
		      status: 'danger',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end',
		     duration: 7200000  })
		 
	     return
	   }

	
	  if(data?.type === 'videoStoppedByLimit'){
		 
		   this.toastrService.show('Обробка відео зупинена','Перевищено ліміт у безкоштовному тарифі',{
		      status: 'danger',
		      icon: '',
		      position: <NbGlobalPosition>'bottom-end',
		     duration: 7200000  })
		 return
	     
	   }
	if(data?.type === 'bindNewTariff'){

			if(data.payload?.blocked !== undefined){
			    	 this.authService.setBlockedByPayment(data.payload.blocked)
			}

		        if(data.payload?.balance !== undefined){
			     this.authService.setBalance(data.payload.balance)
			}

			if(data.payload?.tariff !== undefined){
			   this.authService.currentTariff = data.payload?.tariff
			}
		  return
        }	


       
/*
	if(data?.type === 'mediaChanged'){
		if(data?.payload !== undefined){

			let usage = data?.payload;
				if(usage){
				//this.authService.setMediaUsed((usage / 60 / 60).toFixed(2))
				this.authService.setMediaUsed(usage)
				}else{

				this.authService.setMediaUsed(0)
				}
		}
 	  return
        } */
 


       //fromAcquiring


	if(data?.type === 'balanceIsReplenished'){
		if(data?.payload !== undefined){

			 
			if(data.payload?.balance !== undefined){
			     this.authService.setBalance(data.payload.balance)
			}

			
			if(data.payload?.blocked !== undefined){

			    	 this.authService.setBlockedByPayment(data.payload.blocked)
 
			}

			this.gAnalytics.trackEvent('Payok')   
		}
 	  return
        }


	if(data?.type === 'resetBalanceWithoutMedia'){
		if(data?.payload !== undefined){

			 
			if(data.payload?.balance !== undefined){
			     this.authService.setBalance(data.payload.balance)
			}

			
			if(data.payload?.blocked !== undefined){

			    	 this.authService.setBlockedByPayment(data.payload.blocked)
 
			}
		}
 	  return
        }

	if(data?.type === 'resetBalance'){
		if(data?.payload !== undefined){

			//  this.authService.setMediaUsed(0)

			if(data.payload?.balance !== undefined){
			     this.authService.setBalance(data.payload.balance)
			}

			
			if(data.payload?.blocked !== undefined){

			    	 this.authService.setBlockedByPayment(data.payload.blocked)
 
			}
		}
 	  return
        }
 
	/* if(data?.type === 'storageChanged'){
		if(data?.payload !== undefined){

			let usage = data?.payload;
				if(usage){
				//this.authService.setStorageUsed((usage / 60 / 60).toFixed(2))

				this.authService.setStorageUsed(parseInt(usage).toFixed(0) || 0)
				}else{

				this.authService.setStorageUsed(0)
				}
		}
 	  return
        } */
 
	if(data?.type === 'blockStatusChanged'){
		if(data?.payload !== undefined){
			this.authService.setBlockedStatus(data?.payload)
		}
 	  return
        }

        if(data?.type === 'balanceChanged'){
		if(data?.payload !== undefined){
			this.authService.setBalance(data?.payload)
		}
 	  return
        }

	
	if(data?.type === 'logoutNow'){
		  this.authService.logout()
		this.router.navigate(['/login'])
 	  return
        }
 


  }


  loadUserData(){ 
    if(this.authService.isAuthenticated && !this.authService.userDataLoaded){

      this.authService.loadUserData().subscribe(()=>{
       this.loadingDone()
	this.reloadsCount = 0
      }, (error)=>{
 
		if(error.status === 401){
			this.authService.logout()
		        this.router.navigate(['/login'])
		
		}else{

		if(this.reloadsCount < 3){

	  	this.reloadsCount = this.reloadsCount +1;
  
		setTimeout(()=>{
	    	   this.loadUserData()
		},2000)

		} 

		}
	/**/
      })
    }else{
	this.loadingDone()
    }
 
  }



  loadMenu(items, pushto){
	items.map(async (item:any)  =>{


			
		/* */
			 (await ( new Promise((resolve)=>{
				this.translateService.get(`account.menu.left.${item.title}`).subscribe(title=>{

					let it = {...item}
					//console.log(title, item.title)
					it.title  = title || item.title
					 
					if(item.children?.length){
						this.loadMenu(item.children, (it.children = [] ) )
					}
					
					pushto.push(it)

				
					resolve()
				})  
			}) ))
			return item	
		})
  }

  async loadingDone(){


	  this.loadMenu(MENU_ITEMS,this.menu)


	if(this.authService.isAdmin()){

		//this.menu = MENU_ADMIN_ITEMS


		this.menu.push(...MENU_ADMIN_ITEMS)
 
		//this.menu = items

		/*if(this.menu[this.menu.length -1].link !== '/admin'){
			this.menu.push({
			  title: 'Администрирование',
			    icon: 'settings-2-outline',
			     link: '/admin',
			    home: false

			})
		} */

	}else{

		/*if(this.menu[this.menu.length -1].link == '/admin'){
			this.menu.pop()
		}*/



		//this.menu = MENU_ITEMS
		
		/*.map((item:any)=>{

			item.title += "123"
			return item
		}) */

		//this.menu = MENU_ITEMS		
	}

	this.loaded = true	
  }


 ngAfterViewInit() {

  }

  logout(event:Event) {
    event.preventDefault()
    this.authService.logout()
    this.router.navigate(['/login'])
  }

   ngOnDestroy(){
    this.socket.disconnect()
    this.socket.removeAllListeners('cmd')

  }
}
